"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UILoadingDots;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _theme = require("HubStyleTokens/theme");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _BrowserTest = require("../utils/BrowserTest");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var loadingColorAnimation = (0, _styledComponents.keyframes)(["25%{background-color:", ";}75%{background-color:", ";}"], _theme.LOADING_INACTIVE_COLOR, _theme.LOADING_INACTIVE_COLOR);
var loadingAnimation = (0, _styledComponents.keyframes)(["0%,100%{transform:translateY(0);}25%{transform:translateY(.25em);}50%{transform:translateY(0);}75%{transform:translateY(-.25em);}"]);

if ((0, _BrowserTest.isIE11)()) {
  // Fix for #5734
  loadingAnimation = (0, _styledComponents.keyframes)(["0%,100%{top:0;}25%{top:.25em;}50%{top:0}75%{top:-.25em;}"]);
}

var Dot = _styledComponents.default.div.withConfig({
  displayName: "UILoadingDots__Dot",
  componentId: "sc-1dukb3m-0"
})(["position:relative;background-color:currentColor;color:", ";border-radius:50%;height:1em;width:1em;animation:", ",", ";animation-duration:1s;animation-timing-function:linear;animation-iteration-count:infinite;&:not(:last-child){margin-right:0.75em;}&:nth-child(2){animation-delay:-0.66s;}&:nth-child(3){animation-delay:-0.33s;}"], _theme.LOADING_DEFAULT_COLOR, loadingAnimation, loadingColorAnimation);

var LoadingDots = _styledComponents.default.div.withConfig({
  displayName: "UILoadingDots__LoadingDots",
  componentId: "sc-1dukb3m-1"
})(["display:flex;align-items:center;justify-content:center;height:1.25em;width:4.5em;", ";"], function (props) {
  return props.grow && "width: 100%; height: 100%;";
});

var getTranslatedTitle = function getTranslatedTitle() {
  return _I18n.default.text('salesUI.UILoading.title');
};

var getStyle = function getStyle(minHeight, style) {
  return minHeight ? Object.assign({}, style, {
    minHeight: minHeight
  }) : style;
};

function UILoadingDots(props) {
  var className = props.className,
      grow = props.grow,
      minHeight = props.minHeight,
      style = props.style,
      title = props.title,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "grow", "minHeight", "style", "title"]);
  return _react.default.createElement(LoadingDots, Object.assign({
    className: (0, _classnames.default)(className, 'uiLoading', {
      'uiLoading-grow': grow
    }),
    "data-loading": true,
    style: getStyle(minHeight, style),
    title: (0, _lazyEval.default)(title),
    grow: grow
  }, rest), _react.default.createElement(Dot, {
    className: "uiLoadingDot dot-1"
  }), _react.default.createElement(Dot, {
    className: "uiLoadingDot dot-2"
  }), _react.default.createElement(Dot, {
    className: "uiLoadingDot dot-3"
  }));
}

UILoadingDots.propTypes = {
  grow: _propTypes.default.bool.isRequired,
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  title: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired
};
UILoadingDots.defaultProps = {
  grow: true,
  title: getTranslatedTitle
};
UILoadingDots.displayName = 'UILoadingDots';
module.exports = exports.default;